import React from 'react'

import RestrictedComponent from '../../../../lib/components/form/RestrictedComponent'


const RecordActionButton = (props) => {
  const { permissionCheck, title, className, disabled, onClick, imageElement } = props

  return (
    <RestrictedComponent
      key={`restricted action button ${title}`}
      permissionCheck={permissionCheck}
    >
      <button
        title={title}
        key={`action button ${title}`}
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {imageElement}
      </button>
    </RestrictedComponent>
  )
}

export default RecordActionButton
